module.exports = "<h1>{{message}}</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common-app/component/error/error.component.html
// module id = ./src/app/common-app/component/error/error.component.html
// module chunks = main